function setSessionCookie(cname, cvalue, exminutes, expireUser) {
  let d = new Date()
  d.setTime(d.getTime() + (exminutes * 60 * 1000))
  let expires = "expires="+d.toUTCString() 
  let domain = location.hostname.replace('www.','')
  let array = [] 
  array.push(cvalue)
  if (typeof expireUser != 'undefined') {
    array.push(expireUser) 
    expires = expireUser
  }else{
    array.push(expires)   
  }
  array = JSON.stringify(array)
  document.cookie = `${cname}=${array};${expires};domain=${domain};path=/`
}

function getSessionCookie(cname) {
  let name = cname + "="
  let ca = document.cookie.split(';')
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i]
    while (c.charAt(0) == ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ""
}

function deleteSessionCookie(cname) {
  setSessionCookie(cname, '', 0)
}

function initSessionCookie(itemKey, initValue){
    itemKey = itemKey || ''
    initValue = typeof initValue == 'undefined' ? '' : initValue 
    let _initSessionCookie = () => {
      if(!getSessionCookie(itemKey)) {
        let type = typeof initValue
        switch (type) {
          case 'object':
            setSessionCookie(itemKey, initValue, 30)
            break
          case 'number':
          case 'string':
            setSessionCookie(itemKey, initValue, 30)
            break  
          default:
            throw new Error(`type [${type}] init sessionStorage not supported`)
        }
      }
    } 
    let _destroySessionCookie = (name) => {
      deleteSessionCookie(name)
      return 'deleted'
    }
    let _getValueItemSessionCookie = (allObjects) => {
      _initSessionCookie()  
      if (typeof allObjects == 'undefined'){
        return typeof initValue == 'object' ? JSON.parse(getSessionCookie(itemKey))[0] : getSessionCookie(itemKey)
      }
      return typeof initValue == 'object' ? JSON.parse(getSessionCookie(itemKey)) : getSessionCookie(itemKey)
          
    } 
    let _setValueItemSessionCookie = (value, keepOldExpire) => {
      let items = _getValueItemSessionCookie(true)
      let item = items[0]
      let oldExpire = items[1]
      if(typeof item == 'object'){        
        if (item.length == 4){
          item.shift()
        }
        item.push(value)
        typeof keepOldExpire != 'undefined' ? setSessionCookie(itemKey, item, 30, oldExpire) : setSessionCookie(itemKey, item,30)
      } else setSessionCookie(itemKey, value,30)
    }
    let _updateOptionClickedSessionCookie = (value) => {
      let items = _getValueItemSessionCookie(true)
      let item = items[0]
      let oldExpire = items[1]
      if(typeof item == 'object'){
        let foundIndex = item.findIndex((x => x.id == value.id_option))  
        if(item[foundIndex].type === 'option'){
          let optionIndexClicked = item[foundIndex].payload.options.findIndex((x => x.label === value.labelButton))
          item[foundIndex].payload.options[optionIndexClicked].clicked = 'reply-clicked'
          setSessionCookie(itemKey, item, 30, oldExpire)
        } 
      }
    }
    let _isEmptySessionCookie = () => {
      let items = _getValueItemSessionCookie() 
      if (typeof items === 'undefined' || items.length == 0) return true
      return false
    }
    return {
      set     : _setValueItemSessionCookie,
      get     : _getValueItemSessionCookie,
      delete  : _destroySessionCookie,
      updateOption: _updateOptionClickedSessionCookie,
      isEmpty : _isEmptySessionCookie
    }
  }
  initSessionCookie()
  export default initSessionCookie
  
 